
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface AccessDeniedProps {
  isLoggedIn: boolean;
  isCreator: boolean;
}

const AccessDenied: React.FC<AccessDeniedProps> = ({ isLoggedIn, isCreator }) => {
  const navigate = useNavigate();
  
  if (!isLoggedIn) {
    return (
      <div className="text-center p-8">
        <h2 className="text-2xl font-semibold mb-4">Creator Access Required</h2>
        <p className="mb-4">You need to be logged in as a creator to upload agents.</p>
        <div className="flex justify-center gap-4">
          <Button onClick={() => navigate("/login")}>
            Sign In
          </Button>
          <Button variant="outline" onClick={() => navigate("/register")}>
            Register
          </Button>
        </div>
      </div>
    );
  }
  
  if (!isCreator) {
    return (
      <div className="text-center p-8">
        <h2 className="text-2xl font-semibold mb-4">Creator Access Required</h2>
        <p className="mb-4">Only creators can upload agents. Your account is registered as a buyer.</p>
        <Button variant="outline" onClick={() => navigate("/")}>
          Go Back
        </Button>
      </div>
    );
  }
  
  return null;
};

export default AccessDenied;
